import module from 'recursoshumanos/module.js'
import template from './template.html'
import { inRange, isDate, orderBy } from 'lodash'

export class RecursoshumanosComparativasuanominaComponent {
  empresaId
  periodo
  mes
  fecha = null
  procesando = false
  catalogo = {
    empresa: [],
  }

  constructor ($location, RecursoshumanosComparativasuanominaService, RecursoshumanosOperadorasService) {
    this.$location = $location
    this.RecursoshumanosComparativasuanominaService = RecursoshumanosComparativasuanominaService
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
  }

  $onChanges (changes) {
    if (changes.periodo || changes.mes) {
      if (inRange(this.periodo, 0, 10000) && inRange(this.mes, 0, 13)) {
        this.fecha = new Date(this.periodo, this.mes - 1, 1)
      } else {
        const hoy = new Date()
        this.fecha = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
      }
    }
  }

  $onInit () {
    this.promise = this.RecursoshumanosOperadorasService.get()
      .then(({data}) => (this.catalogo.empresa = orderBy(data, ['descripcion'])))
    this.buscarInformacion()
  }

  buscarInformacion () {
    if (this.procesando) return
    if (!this.empresaId || !isDate(this.fecha)) return

    this.procesando = true
    this.periodo = this.fecha.getFullYear()
    this.mes = this.fecha.getMonth() + 1
    this.data = null

    this.$location.replace()
    this.$location.search({
      empresa_id: this.empresaId,
      periodo: this.periodo,
      mes: this.mes,
    })

    return this.RecursoshumanosComparativasuanominaService.get(this.empresaId, this.periodo, this.mes)
      .then(({data}) => (this.data = orderBy(data)))
      .finally(() => (this.procesando = false))
  }
}

module.component('recursoshumanosComparativasuanomina', {
  controller: RecursoshumanosComparativasuanominaComponent,
  template,
  bindings: {
    empresaId: '<',
    periodo: '<',
    mes: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/comparativaSuaNomina/component.js